// extracted by mini-css-extract-plugin
module.exports = {"root":"Map_root__RzSUy","paper":"Map_paper__3VBiB"};